<template>
  <div class="schedule schedule--service background-gray min-height-inherit">
    <section class="py-4 py-md-5">
      <div class="container container--md">
        <header class="mb-4">
          <h1 class="title title--main">
            Selecciona uno de los ({{ services.length }}) servicios
          </h1>
        </header>

        <div v-if="services.length">
          <div
            v-for="service in services"
            class="mb-3 last-child"
            :key="service.id"
          >
            <card-content :data="service" @set-service="onSetService" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getServices } from '@/services/services';

import CardContent from '@/components/CardContent.vue';
import Auth from '@/helpers/auth';

export default {
  name: 'ScheduleService',
  mixins: [Auth],
  components: {
    CardContent,
  },
  data() {
    return {
      loading: false,
      services: [],
      selected_service: null,
    };
  },
  mounted() {
    this.$store.commit('set_title', 'Estás agendando');

    this.checkAuth();

    this.executeDataLayer();

    this.$store.dispatch('setCurrentStep', 1);
    this.handleGetServices();
  },
  methods: {
    executeDataLayer: async function() {
      if (!window.dataLayer) {
        return;
      }

      const eventData = {
        event: 'agendamiento-paso',
        paso: 1,
      };

      console.log('Sent to dataLayer', eventData);

      window.dataLayer.push(eventData);
    },
    handleGetServices() {
      let brand = null;
      if (
        this.$store.state.current_user &&
        this.$store.state.current_user.car &&
        this.$store.state.current_user.car.brand
      ) {
        brand = this.$store.state.current_user.car.brand.code;
      }

      this.getServicesFromApi(brand)
        .then(services => (this.services = services))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido obtener los servicios',
          });
        });
    },
    onSetService(data) {
      this.loading = true;

      const service_slug = data.name.toSlug();
      data.service_slug = service_slug;

      try {
        window.dataLayer.push({
          event: 'select_content',
          content_type: service_slug,
        });
      } catch (e) {
        console.error('Error sending to dataLayer', e);
      }

      this.$store
        .dispatch('setSelectedService', data)
        .then(() =>
          this.$router.push({
            name: 'schedule-place',
            params: { service: service_slug },
          }),
        )
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido registrar el servicio seleccionado',
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
    async getServicesFromApi(brand) {
      const response = await getServices(brand);
      return response.data.data;
    },
  },
};
</script>
